import React from 'react';
import { useTranslation } from 'react-i18next';

const Line = ({ label, value }) => (
    <div className="flex justify-between gap-4 px-4 py-2.5 text-sm">
        <span className="text-muted-foreground">{label}</span>
        <span className="text-right break-all">{value ?? '–'}</span>
    </div>
);

export function TechCard({ tech }) {
    const { t } = useTranslation();
    return (
        <section className="mb-6">
            <h3 className="text-sm font-semibold uppercase tracking-wide text-muted-foreground mb-2">{t('maison.tech.title')}</h3>
            <div className="bg-card border border-border rounded-xl divide-y divide-border">
                {tech ? (
                    <>
                        <Line label={t('maison.tech.network')} value={tech.wifi} />
                        <Line label={t('maison.tech.signal')} value={tech.rssi} />
                        <Line label={t('maison.tech.firmware')} value={tech.firmware} />
                        <Line label={t('maison.tech.mcu')} value={tech.mcu} />
                    </>
                ) : (
                    <div className="px-4 py-3 text-sm text-muted-foreground">{t('maison.tech.unavailable')}</div>
                )}
            </div>
        </section>
    );
}

export function DiagnosticCard({ diagnostic }) {
    const { t } = useTranslation();
    const reported = Object.entries(diagnostic?.reported ?? {});
    const missing = diagnostic?.missing ?? [];
    if (!reported.length && !missing.length) return null;

    return (
        <details className="bg-card border border-border rounded-xl mb-6">
            <summary className="cursor-pointer select-none px-4 py-3 text-sm font-semibold uppercase tracking-wide text-muted-foreground">
                {t('maison.diagnostic.title')}
                <span className="ml-2 normal-case font-normal tracking-normal">· {t('maison.diagnostic.hint')}</span>
            </summary>
            <div className="border-t border-border divide-y divide-border font-mono text-xs">
                {reported.map(([dps, value]) => (
                    <div key={dps} className="flex justify-between gap-4 px-4 py-2">
                        <span className="text-muted-foreground">DPS {dps}</span>
                        <span className="text-right break-all">{String(value)}</span>
                    </div>
                ))}
                {missing.map(dps => (
                    <div key={dps} className="flex justify-between gap-4 px-4 py-2 text-muted-foreground">
                        <span>DPS {dps}</span>
                        <span className="text-right italic">{t('maison.diagnostic.notReported')}</span>
                    </div>
                ))}
            </div>
        </details>
    );
}
